// extracted by mini-css-extract-plugin
export default {"allContacts":"App_allContacts__F3nfD","titleContacts":"App_titleContacts__5BINW"};